class AnimationSubsHero {

	constructor(args = { sectionsContainer: document }) {
		this.sectionsContainer = args.sectionsContainer;
		this.$moduleSubsHero = this.sectionsContainer.querySelectorAll('.subs-hero');
		
		if (!this.$moduleSubsHero.length)
			return;
		
		this.$moduleSubsHeroElements = [];
		this.$moduleSubsHero.forEach(module => {
			this.$moduleSubsHeroElements.push(module.querySelectorAll('.anima'));
		});

		this.init();
	}

	/* eslint-disable class-methods-use-this, no-unused-vars */
	init() {
		this.setAnimation();
	}

	setAnimation() {
		this.$moduleSubsHero.forEach((module, index) => {
		    console.log(this.$moduleSubsHeroElements[index])
			gsap.set(module, { opacity: 1 });
			gsap.set(this.$moduleSubsHeroElements[index], { yPercent: 20, opacity: 0, onComplete: () => {
				this.initAnimate(index);
			} });
		});
	}

	initAnimate(index) {
		const moduleSubsHero = gsap.timeline({
			defaults: { duration: 1.2, ease: 'power4.out' },
            scrollTrigger: {
                trigger: this.$moduleSubsHero[index],
				start: '-20% 50%'
			},
			onComplete: () => {
				gsap.set(this.$moduleSubsHeroElements[index], { clearProps: true });
			}
        });

        moduleSubsHero.addLabel('step1');
        moduleSubsHero.to(this.$moduleSubsHero[index], { opacity: 1, duration: 1 }, 'step1');
		moduleSubsHero.to(this.$moduleSubsHeroElements[index], { yPercent: 0, opacity: 1, stagger: 0.2 }, 'step1+=0.3');
	}
	/* eslint-enable class-methods-use-this, no-unused-vars */
}
export default AnimationSubsHero;
